import styled from 'styled-components'

import { helpers } from 'styles'

export const Name = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	text-transform: uppercase;
	font-size: 16px;
	font-family: ${helpers.font.family.header};
	color: ${helpers.color.pageHeaderText};
	line-height: 1;
	font-weight: 600;

	> span:first-child {
		font-size: 11px;
		font-weight: 400;
	}
`
